import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import cx from 'classnames';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '../icon/CloseIcon';

/**
 * tag button used for filtering. can be 'removed'
 */
class TagButton extends Component {
    render() {
        const { classes, onClickRemove, text, className } = this.props;

        return (
            <span color="primary" className={cx(classes.root, className)}>
                <span className={classes.text}>{text}</span>
                {onClickRemove && (
                    <IconButton onClick={onClickRemove} className={classes.icon} title="Remove" size="large">
                        <div>
                            <CloseIcon />
                        </div>
                    </IconButton>
                )}
            </span>
        );
    }
}

const styles = ({ palette, funeralHome }) => ({
    root: {
        backgroundColor: palette.primary.main,
        borderRadius: '8px',
        color: '#FFFFFF',
        padding: '0 6px',
        display: 'inline-flex',
        fontSize: '0.875rem',
        minHeight: '1.5rem',
        alignItems: 'center'
    },
    text: {
        whiteSpace: 'nowrap'
    },
    icon: {
        height: '20px',
        width: '20px',
        marginLeft: '8px',
        padding: 0,
        '& > div': {
            border: '1px solid #FFFFFF',
            height: '18px',
            width: '18px',
            borderRadius: '50%',
            padding: '2px',
            color: palette.button.destroy,
            background: '#ffffffCC',
            '&:hover': {
                color: '#fff',
                background: palette.button.destroy
            },
            '& > svg': {
                height: '12px',
                width: '12px',
                color: 'inherit',
                display: 'block'
            }
        }
    }
});

export default withStyles(styles)(TagButton);
